// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"2b393b6c","149":"92fb3cc7","190":"77e2d73f","270":"0ef632c8","707":"03d56fa9","725":"581aae8f","777":"6c707cf1","814":"135e8c87","906":"dd0d0233","942":"81387a84"}[chunkId] + ".chunk.js";
};